export const commonParams = {
  g_tk: 976692372,
  inCharset: 'utf-8',
  outCharset: 'utf-8',
  notice: 0,
  format: 'json',
  _: new Date().getTime()
}

export const options = {
  param: 'jsonpCallback',
  prefix: 'never_yu_'
}

export const ERR_OK = 0



// WEBPACK FOOTER //
// ./src/api/config.js